import React, { useEffect, useState } from "react";
import { Upload, Modal, message, Spin, Alert } from "antd";
import { InboxOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

// Minimum resolution
const MIN_WIDTH = 800;
const MIN_HEIGHT = 600;

const FileUploadDialog = ({
  visible,
  onClose,
  selectedEvent,
  addEventImages,
  addEventImagesLoading,
  addEventImagesSuccess,
  addEventImagesReset,
}) => {
  const [resolutionError, setResolutionError] = useState("");

  useEffect(() => {
    if (addEventImagesSuccess) {
      onClose();
      addEventImagesReset();
    }
  }, [addEventImagesSuccess, onClose, addEventImagesReset]);

  const checkImageResolution = (file) => {
    return new Promise((resolve, reject) => {
      const img = new window.Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (img.width < MIN_WIDTH || img.height < MIN_HEIGHT) {
          reject(
            `Image must be at least ${MIN_WIDTH}x${MIN_HEIGHT} pixels. Your image is ${img.width}x${img.height}.`
          );
        } else {
          resolve();
        }
      };
      img.onerror = () => {
        reject("Could not read image file.");
      };
    });
  };

  const handleUpload = async ({ file, onError, onProgress, onSuccess }) => {
    setResolutionError(""); // Reset error
    try {
      await checkImageResolution(file);
    } catch (errMsg) {
      setResolutionError(errMsg);
      onError(errMsg);
      message.error(errMsg);
      return;
    }

    let progress = 0;
    const fakeProgress = setInterval(() => {
      progress += 20;
      if (progress < 100) {
        onProgress({ percent: progress });
      } else {
        clearInterval(fakeProgress);
      }
    }, 500);

    try {
      clearInterval(fakeProgress);
      await addEventImages({ eventId: selectedEvent, imageData: [file] });
      onSuccess("File uploaded successfully", file);
      message.success(`${file.name} uploaded successfully!`);
    } catch (error) {
      clearInterval(fakeProgress);
      onError(error);
      message.error(`${file.name} upload failed!`);
    }
  };

  const props = {
    name: "file",
    multiple: true,
    customRequest: handleUpload,
    disabled: addEventImagesLoading,
    beforeUpload: () => {
      setResolutionError(""); // Clear error on new selection
      return true;
    },
  };

  return (
    <Modal
      title="Add Images"
      open={visible}
      width="50vw"
      onCancel={() => onClose()}
      footer={null}
    >
      {addEventImagesLoading && (
        <div className="flex justify-center mb-4">
          <Spin size="large" />
        </div>
      )}
      {resolutionError && (
        <Alert
          message={resolutionError}
          type="error"
          showIcon
          className="mb-4"
        />
      )}
      <Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Supports single or bulk uploads. <br />
          <b>Minimum resolution: {MIN_WIDTH}x{MIN_HEIGHT} pixels.</b>
        </p>
      </Dragger>
    </Modal>
  );
};

export default FileUploadDialog;